import React from "react";
import { useApp } from "../components/AppContext";
import { MainLayout } from "../components/MainLayout";
import { ExternalLink, Mail } from "lucide-react";
import { useTranslation } from "../i18n/TranslationContext";
import { useCurrentUser } from "@/api";

export function InfoFAQ() {
	const { navigateDirectly } = useApp();
	const { t } = useTranslation();

	const { user } = useCurrentUser();

	const handleRegistrationClick = () => {
		window.open(
			user?.internal_extra
				? "https://ucm.agency/de/fraport-basisprobebetrieb-anmeldung/"
				: "https://ucm.agency/de/anmeldung-terminal-3-frankfurt/",
			"_blank"
		);
	};

	const handleEmailClick = () => {
		const email = "orat-t3@ucm.agency";
		const mailtoLink = `mailto:${email}`;
		window.location.href = mailtoLink;
	};

	return (
		<MainLayout showBack={true} onBack={() => navigateDirectly("app-settings")}>
			<div className="flex flex-col h-full">
				{/* Header */}
				<div className="bg-gradient-to-b px-4 mb-6">
					<h1 className="text-2xl font-bold text-[var(--ucm-text-dark)] mb-2">
						{t("appSettings.sections.help")}
					</h1>
					<p className="text-[var(--ucm-text-medium)]">
						{t("infoFAQ.subtitle")}
					</p>
				</div>

				{/* Content */}
				<div className="px-4 space-y-6 pb-6">
					{/* Registration Information Section */}
					<div className="bg-white rounded-2xl p-6 shadow-[0_4px_16px_rgba(0,0,0,0.08)]">
						<h2 className="text-lg font-semibold text-[var(--ucm-text-dark)] mb-3">
							{t("infoFAQ.registrationTitle")}
						</h2>
						<p className="text-sm text-[var(--ucm-text-medium)] mb-4">
							{t("infoFAQ.registrationDescription")}
						</p>
						<button
							onClick={handleRegistrationClick}
							className="w-full h-12 bg-[var(--ucm-primary-teal)] text-white font-semibold rounded-full hover:bg-[var(--ucm-primary-teal-hover)] transition-colors duration-200 flex items-center justify-center gap-2"
						>
							<span>{t("infoFAQ.visitRegistrationPage")}</span>
							<ExternalLink size={18} />
						</button>
					</div>

					{/* Contact Support Section */}
					<div className="bg-white rounded-2xl p-6 shadow-[0_4px_16px_rgba(0,0,0,0.08)]">
						<h2 className="text-lg font-semibold text-[var(--ucm-text-dark)] mb-3">
							{t("infoFAQ.contactTitle")}
						</h2>
						<p className="text-sm text-[var(--ucm-text-medium)] mb-4">
							{t("infoFAQ.contactDescription")}
						</p>
						<p className="text-sm font-medium text-[var(--ucm-text-dark)] mb-4">
							orat-t3@ucm.agency
						</p>
						<button
							onClick={handleEmailClick}
							className="w-full h-12 bg-[var(--ucm-primary-teal)] text-white font-semibold rounded-full hover:bg-[var(--ucm-primary-teal-hover)] transition-colors duration-200 flex items-center justify-center gap-2"
						>
							<span>{t("infoFAQ.sendEmail")}</span>
							<Mail size={18} />
						</button>
					</div>
				</div>
			</div>
		</MainLayout>
	);
}
